import React, { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArticleIcon from '@mui/icons-material/Article';

const ReportActionsMenu = ({ filePath, disabled = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    event.stopPropagation();
    if (!disabled) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownload = () => {
    if (filePath) {
      window.open(filePath, '_blank');
    }
    handleClose();
  };

  return (
    <>
      <IconButton
        aria-label={'more'}
        aria-controls="long-menu"
        aria-haspopup="true"
        onClick={handleClick}
        disabled={disabled}
        sx={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu id="long-menu" anchorEl={anchorEl} open={open} onClose={handleClose} onClick={(e) => e.stopPropagation()}>
        <MenuItem onClick={handleDownload} disabled={!filePath}>
          <ArticleIcon sx={{ mr: 1 }} />
          {'Download Report'}
        </MenuItem>
      </Menu>
    </>
  );
};

export default ReportActionsMenu;
